import { render, staticRenderFns } from "./ERDTable.vue?vue&type=template&id=2ddbd238&scoped=true&%3Akey=currentKey&"
import script from "./ERDTable.vue?vue&type=script&lang=js&"
export * from "./ERDTable.vue?vue&type=script&lang=js&"
import style0 from "./ERDTable.vue?vue&type=style&index=0&id=2ddbd238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddbd238",
  null
  
)

export default component.exports